import { cn } from "@/lib/utils";

const ROLE_STYLES = {
  staff: "bg-[#eef2fb] text-[#206bc4] border-[#d1e0f5] dark:border-[#1e3a8a]",
  partner: "bg-[#fef3c7] text-[#b45309] border-[#fde68a]",
  customer: "bg-[#f1f5f9] text-[#475569] border-[#e2e8f0]",
};
const ROLE_LABELS = { staff: "Staff", partner: "Partner", customer: "Customer" };

export function RoleBadge({ role, label, className }) {
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold",
        ROLE_STYLES[role] || ROLE_STYLES.customer,
        className
      )}
    >
      {label || ROLE_LABELS[role] || role}
    </span>
  );
}

const STATUS_STYLES = {
  active: "bg-[#dcfce7] text-[#166534]",
  suspended: "bg-[#fef08a] text-[#854d0e]",
  deactivated: "bg-[#fee2e2] text-[#991b1b]",
};

export function StatusChip({ status, className }) {
  return (
    <span
      data-testid={`status-chip-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium capitalize",
        STATUS_STYLES[status] || STATUS_STYLES.active,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
